import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { MegaData } from "./menu-data";
import { PromoAside } from "./PromoAside";

export function MegaMenu({
  data,
  open,
  onMouseEnter,
  onMouseLeave,
  title,
}: {
  data: MegaData;
  open: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  title: string;
}) {
  return (
    <div
      className={cn(
        "fixed inset-x-0 top-[56px] md:top-[72px] z-50 border-t border-n-green-6",
        open ? "pointer-events-auto" : "pointer-events-none"
      )}
      role="dialog"
      aria-hidden={!open}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        className={cn(
          "mx-auto mt-3 w-[min(1300px,92vw)] rounded-2xl bg-white shadow-xl ring-1 ring-black/5",
          open ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1",
          "transition-all duration-150",
          "min-h-[400px]"
        )}
      >
        <div className="flex gap-8 items-stretch">
          <div className="flex-1 flex-col p-6">
            <p className="text-2xl font-semibold text-n-text-green mb-3">
              {title}
            </p>
            <div className="grid flex-1 grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              {data.groups.map((group) => (
                <div
                  key={group.title}
                  className="min-w-0 border-l border-n-green-text pl-4"
                >
                  <p className="text-md font-semibold text-n-text-green">
                    {group.title}
                  </p>
                  <ul className="space-y-1.5 pl-1 mt-2">
                    {group.items.map((item) => (
                      <li key={item.label}>
                        <Link
                          className="cursor-pointer block px-2 py-2 transition-colors rounded-r-md hover:bg-n-green-h-light text-n-text-green hover:border-l-2 hover:border-n-secondary hover:pl-[6px]"
                          to={item.to}
                          onClick={onMouseLeave}
                        >
                          <p className="font-medium">{item.label}</p>
                          {item.description && (
                            <p className="text-xs text-n-text-neutral">
                              {item.description}
                            </p>
                          )}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
          <PromoAside />
        </div>
      </div>
    </div>
  );
}
